<script>
import CostListDesktopView from "./CostListDesktopView.vue";

/**
 * Desktop list layout bridge.
 * Renders CostListDesktopView using the parent cost-list instance as
 * context so template bindings and $refs stay on costList.vue (provide/inject).
 */
export default {
  name: "CostListDesktopBridge",
  inject: ["costList"],
  render() {
    const costList = this.costList;
    const viewOptions = CostListDesktopView.options || CostListDesktopView;
    const render = viewOptions.render;

    if (!costList || typeof render !== "function") {
      return null;
    }

    const options = costList.$options;
    const prevStaticRenderFns = options.staticRenderFns;
    const prevScopeId = options._scopeId;

    options.staticRenderFns = viewOptions.staticRenderFns;
    if (viewOptions._scopeId) {
      options._scopeId = viewOptions._scopeId;
    }

    try {
      return render.call(costList, costList.$createElement);
    } finally {
      options.staticRenderFns = prevStaticRenderFns;
      options._scopeId = prevScopeId;
    }
  },
};
</script>
